import { useState } from "react";
import Select, { components } from "react-select";


const Option = (props: any) => (
  <components.Option {...props} className="super-select--option">
    <img src={props.data.icon} alt="logo" className="super-select__logo" />
    <div className="super-select__text">{props.data.label}</div>
  </components.Option>
);

const SuperSelect = (args: any) => {
  const options = args.options;
  const onChange = args.onChange;
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const handleChange = (value: any) => {
    setSelectedOption(value);
    onChange(value.value)
  };

  const SingleValue = ({ children, ...props }: any) => (
    <components.SingleValue {...props}>
      <img src={selectedOption.icon} alt="s-logo" className="super-select__logo" />
      <div className="super-select__text">{children}</div>
    </components.SingleValue>
  );

  return (
    <Select
    value={selectedOption}
    options={options}
    className="source-select"
    onChange={handleChange}
    styles={{
      singleValue: (base: any) => ({
        ...base,
        display: "flex",
        alignItems: "center",
        padding: 0
      })
    }}
    components={{
      Option,
      SingleValue
    }}
  />
  );
};

export default SuperSelect;
